import type { CreateUIAnalyticsEvent } from '@atlaskit/analytics-next';

import type { IneligibilityReason } from './resolve-cross-join-third-party-nudges';

export type EVENT_TYPE = 'sendTrackEvent' | 'sendOperationalEvent';

type FireExperimentAnalytics = (
	type: EVENT_TYPE,
	actionSubject: string,
	action: string,
	actionSubjectId?: string,
	attributes?: Record<string, any>,
) => unknown;

export const getExperimentAnalytics =
	(
		createAnalyticsEvent: CreateUIAnalyticsEvent,
		{ attributes: commonAttributes = {} } = {},
	): FireExperimentAnalytics =>
	(type, actionSubject, action, actionSubjectId, attributes) =>
		createAnalyticsEvent({
			type,
			data: {
				action,
				actionSubject,
				actionSubjectId,
				source: 'confluenceCrossJoin3PNudges',
				attributes: {
					...commonAttributes,
					...attributes,
				},
			},
		}).fire();

export const fireEligibilityChecked = (
	analytics: FireExperimentAnalytics,
	ineligibilityReason: IneligibilityReason | 'ELIGIBLE',
) => {
	const flagKey = 'confluenceCrossJoin3PNudges';
	const action = 'tracked';
	analytics('sendTrackEvent', 'eligibility', action, undefined, {
		flagKey,
		ineligibilityReason,
	});
};

export const fireExperimentError = (analytics: FireExperimentAnalytics, error: Error) =>
	analytics('sendOperationalEvent', 'showCrossJoin3PNudges', 'failed', undefined, {
		message: String(error),
		details: { ...(error || {}) },
	});
